<template>

    <div class="newsletter-signup container-fluid theme-dark-blue">
        
		<TitleHeader :subtitle="subtitle" :title="title"></TitleHeader>

		<div class="intro" v-html="body"></div>
		
        <form class="container">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <label for="firstname">First Name</label>
                    <input type="text" name="firstname" id="firstname" placeholder="First Name" required>
                </div>
                <div class="col-sm-12 col-md-6">
                    <label for="lastname">Last Name</label>
                    <input type="text" name="lastname" id="lastname" placeholder="Last Name" required>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <label for="email">Email Address</label>
                    <input type="email" name="email" id="email" placeholder="Email Address" required>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="captcha">
                        <label>Security</label>
                        <div class="g-recaptcha" data-sitekey="6Lfrap0UAAAAADiTC8J3PF6yupUArXWkpoy0PEGg"></div>
                    </div>
                </div>
            </div>
            <button type="submit" disabled>Sign Up</button>
        </form>
    </div>

</template>

<script>

	import TitleHeader from '../Global/TitleHeader.vue';
	
    export default {
		name: 'NewsletterSignup',
		
		props: ['subtitle', 'title', 'body', 'submit', 'forms'],
		
		components: {
			TitleHeader
		}
	}
</script>